import { RouteObject, Navigate } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ProdutosPage from '@/pages/produtos/page';
import CadeirasPage from '@/pages/cadeiras/page';
import MesasPage from '@/pages/mesas/page';
import AcoPage from '@/pages/aco/page';
import MarcasPage from '@/pages/marcas/page';
import CatalogosPage from '@/pages/catalogos/page';
import CatalogoPage from '@/pages/catalogo/page';
import FornecimentoOrgaosPublicosPage from '@/pages/fornecimento-orgaos-publicos/page';
import OrcamentoPage from '@/pages/orcamento/page';
import CasesPage from '@/pages/cases/page';
import ContatoPage from '@/pages/contato/page';
import CabinesPage from '@/pages/cabines/page';
import DivisoriasPage from '@/pages/divisorias/page';
import MarcenariaPage from '@/pages/marcenaria/page';
import RivattiPage from '@/pages/rivatti/page';
import MarzoPage from '@/pages/marzo/page';
import FrisokarPage from '@/pages/frisokar/page';
import PlaxmetalPage from '@/pages/plaxmetal/page';
import PandimPage from '@/pages/pandim/page';
import W3Page from '@/pages/w3/page';
import EscolarPage from '@/pages/escolar/page';
import NotFound from '@/pages/NotFound';
import PrivacidadePage from '@/pages/privacidade/page';
import TurnkeyPage from '@/pages/turnkey/page';
import AreaAtendimentoPage from '@/pages/area-atendimento/page';
import BlogPage from '@/pages/blog/page';
import BlogPostPage from '@/pages/blog/post';
import MoveisCorporativosPage from '@/pages/moveis-corporativos/page';
import SitemapPage from '@/pages/sitemap/page';
import ObrigadoPage from '@/pages/obrigado/page';
import EbooksPage from '@/pages/ebooks/page';
import EbookLandingPage from '@/pages/ebooks/landing';
import CosturaPage from '@/pages/costura/page';
import AutismoPage from '@/pages/autismo/page';
import BoxSantaCruzPage from '@/pages/box-santa-cruz/page';
import ClinicasPage from '@/pages/clinicas/page';
import MarcenariaCorporativaPage from '@/pages/marcenaria-corporativa/page';
import AgronegocioPage from '@/pages/agronegocio/page';
import GastronomiaPage from '@/pages/gastronomia/page';
import TecnologiaPage from '@/pages/tecnologia/page';
import ParceirosPage from '@/pages/parceiros/page';
import AdvogadosPage from '@/pages/advogados/page';
import IgrejasPage from '@/pages/igrejas/page';
import MoveisCorporativosRecifePage from '@/pages/moveis-corporativos-recife/page';
import MoveisCorporativosPetrolinaPage from '@/pages/moveis-corporativos-petrolina/page';
import MoveisCorporativosGaranhunsPage from '@/pages/moveis-corporativos-garanhuns/page';
import MoveisCorporativosCaruaruPage from '@/pages/moveis-corporativos-caruaru/page';
import MoveisCorporativosToritamaPage from '@/pages/moveis-corporativos-toritama/page';
import MoveisCorporativosSantaCruzPage from '@/pages/moveis-corporativos-santa-cruz/page';
import MoveisCorporativosJaboataoPage from '@/pages/moveis-corporativos-jaboatao/page';
import MoveisCorporativosPaulistaPage from '@/pages/moveis-corporativos-paulista/page';
import MoveisCorporativosOlindaPage from '@/pages/moveis-corporativos-olinda/page';
import MoveisCorporativosCaboPage from '@/pages/moveis-corporativos-cabo/page';
import MoveisCorporativosCamaragibePage from '@/pages/moveis-corporativos-camaragibe/page';
import MoveisCorporativosVitoriaPage from '@/pages/moveis-corporativos-vitoria/page';
import MoveisCorporativosIgarassuPage from '@/pages/moveis-corporativos-igarassu/page';
import MoveisCorporativosSaoLourencoPage from '@/pages/moveis-corporativos-sao-lourenco/page';
import MoveisCorporativosAbreuELimaPage from '@/pages/moveis-corporativos-abreu-e-lima/page';
import MoveisCorporativosIpojucaPage from '@/pages/moveis-corporativos-ipojuca/page';
import MoveisCorporativosSerraTalhadaPage from '@/pages/moveis-corporativos-serra-talhada/page';
import MoveisCorporativosCarpina from '@/pages/moveis-corporativos-carpina/page';
import FaqPage from '@/pages/faq/page';
import GlossarioPage from '@/pages/glossario/page';
import CalculadoraPage from '@/pages/calculadora/page';
import ConsultoriaIAPage from '@/pages/consultoria-ia/page';
import HotelariaPage from '@/pages/hotelaria/page';
import AcademiaPage from '@/pages/academia/page';
import CoworkingPage from '@/pages/coworking/page';
import BelezaEsteticaPage from '@/pages/beleza-estetica/page';
import FarmaciasPage from '@/pages/farmacias/page';
import PetShopPage from '@/pages/pet-shop/page';
import ContabilidadePage from '@/pages/contabilidade/page';
import ImobiliariasPage from '@/pages/imobiliarias/page';
import SegmentosPage from '@/pages/segmentos/page';
import HomeOfficePremiumPage from '@/pages/homeoffice-premium/page';
import RastreamentoPage from '@/pages/rastreamento/page';
import PainelClientesPage from '@/pages/painel-clientes/page';
import CaixinhaDeAjudaPage from '@/pages/caixinha-de-ajuda/page';
import PainelShell from '@/pages/painel/page';
import VisaoGeral from '@/pages/painel/components/VisaoGeral';
import Licitacoes from '@/pages/painel/components/Licitacoes';
import CrmModule from '@/pages/painel/components/CrmModule';
import ClientesModule from '@/pages/painel/components/ClientesModule';
import ClienteDetail from '@/pages/painel/components/ClienteDetail';
import RadarModule from '@/pages/painel/components/RadarModule';
import RadarDashboard from '@/pages/painel/components/RadarDashboard';
import RadarOportunidades from '@/pages/painel/components/RadarOportunidades';
import RadarOportunidadeDetail from '@/pages/painel/components/RadarOportunidadeDetail';
import RadarObras from '@/pages/painel/components/RadarObras';
import RadarEmpresas from '@/pages/painel/components/RadarEmpresas';
import RadarFontes from '@/pages/painel/components/RadarFontes';
import RadarArquivadas from '@/pages/painel/components/RadarArquivadas';
import OportunidadesModule from '@/pages/painel/components/OportunidadesModule';
import ProjetosEstrategicos from '@/pages/painel/components/ProjetosEstrategicos';
import Resultados from '@/pages/painel/components/Resultados';
import Configuracoes from '@/pages/painel/components/Configuracoes';
import FornecedoresModule from '@/pages/painel/components/FornecedoresModule';
import RelacionamentosModule from '@/pages/painel/components/RelacionamentosModule';
import ContatoDetail from '@/pages/painel/components/ContatoDetail';
import {
  CrmLeads,
  CrmPipeline,
  CrmWhatsapp,
  CrmCalendario,
  CrmFunil,
  CrmIa,
  CrmFilas,
} from '@/pages/painel/components/CrmSubRoutes';
import ContratoPage from '@/pages/contrato/page';
import ContratoImportadoPage from '@/pages/contrato-importado/page';
import GoogleCallbackPage from '@/pages/google-callback/page';
import LinksPage from '@/pages/links/page';
import EdnilsonLeocadioPage from '@/pages/ednilson-leocadio/page';
import ProjetosCorporativosPage from '@/pages/projetos-corporativos/page';
import CarpeteCorporativoPage from '@/pages/carpete-corporativo/page';
import MobiliarioUrbanoPage from '@/pages/mobiliario-urbano/page';
import PracasAlimentacaoPage from '@/pages/mobiliario-pracas-alimentacao/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomeOfficePremiumPage /> },
  { path: '/produtos', element: <ProdutosPage /> },
  { path: '/cadeiras', element: <CadeirasPage /> },
  { path: '/mesas', element: <MesasPage /> },
  { path: '/aco', element: <AcoPage /> },
  { path: '/marcas', element: <MarcasPage /> },
  { path: '/catalogos', element: <CatalogosPage /> },
  { path: '/catalogo', element: <CatalogoPage /> },
  { path: '/catalogo-interativo', element: <Navigate to="/catalogo" replace /> },
  { path: '/fornecimento-orgaos-publicos', element: <FornecimentoOrgaosPublicosPage /> },
  { path: '/orcamento', element: <OrcamentoPage /> },
  { path: '/cases', element: <CasesPage /> },
  { path: '/contato', element: <ContatoPage /> },
  { path: '/cabines-acusticas', element: <CabinesPage /> },
  { path: '/divisorias', element: <DivisoriasPage /> },
  { path: '/marcenaria', element: <MarcenariaPage /> },
  { path: '/rivatti', element: <RivattiPage /> },
  { path: '/marzo-vitorino', element: <MarzoPage /> },
  { path: '/frisokar', element: <FrisokarPage /> },
  { path: '/plaxmetal', element: <PlaxmetalPage /> },
  { path: '/pandim', element: <PandimPage /> },
  { path: '/w3-industria', element: <W3Page /> },
  { path: '/escolar', element: <EscolarPage /> },
  { path: '/privacidade', element: <PrivacidadePage /> },
  { path: '/turnkey', element: <TurnkeyPage /> },
  { path: '/area-de-atendimento', element: <AreaAtendimentoPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:slug', element: <BlogPostPage /> },
  { path: '/homeoffice-premium', element: <Navigate to="/" replace /> },
  { path: '/lp', element: <Navigate to="/" replace /> },
  { path: '/sitemap', element: <SitemapPage /> },
  { path: '/obrigado', element: <ObrigadoPage /> },
  { path: '/ebooks', element: <EbooksPage /> },
  { path: '/ebooks/:slug', element: <EbookLandingPage /> },
  { path: '/costura', element: <CosturaPage /> },
  { path: '/autismo', element: <AutismoPage /> },
  { path: '/box-santa-cruz', element: <BoxSantaCruzPage /> },
  { path: '/clinicas', element: <ClinicasPage /> },
  { path: '/marcenaria-corporativa', element: <MarcenariaCorporativaPage /> },
  { path: '/agronegocio', element: <AgronegocioPage /> },
  { path: '/gastronomia', element: <GastronomiaPage /> },
  { path: '/tecnologia', element: <TecnologiaPage /> },
  { path: '/parceiros', element: <ParceirosPage /> },
  { path: '/advogados', element: <AdvogadosPage /> },
  { path: '/igrejas', element: <IgrejasPage /> },
  { path: '/moveis-corporativos-recife', element: <MoveisCorporativosRecifePage /> },
  { path: '/moveis-corporativos-petrolina', element: <MoveisCorporativosPetrolinaPage /> },
  { path: '/moveis-corporativos-garanhuns', element: <MoveisCorporativosGaranhunsPage /> },
  { path: '/moveis-corporativos-caruaru', element: <MoveisCorporativosCaruaruPage /> },
  { path: '/moveis-corporativos-toritama', element: <MoveisCorporativosToritamaPage /> },
  { path: '/moveis-corporativos-santa-cruz-do-capibaribe', element: <MoveisCorporativosSantaCruzPage /> },
  { path: '/moveis-corporativos-jaboatao-dos-guararapes', element: <MoveisCorporativosJaboataoPage /> },
  { path: '/moveis-corporativos-paulista', element: <MoveisCorporativosPaulistaPage /> },
  { path: '/moveis-corporativos-olinda', element: <MoveisCorporativosOlindaPage /> },
  { path: '/moveis-corporativos-cabo-de-santo-agostinho', element: <MoveisCorporativosCaboPage /> },
  { path: '/moveis-corporativos-camaragibe', element: <MoveisCorporativosCamaragibePage /> },
  { path: '/moveis-corporativos-vitoria-de-santo-antao', element: <MoveisCorporativosVitoriaPage /> },
  { path: '/moveis-corporativos-igarassu', element: <MoveisCorporativosIgarassuPage /> },
  { path: '/moveis-corporativos-sao-lourenco-da-mata', element: <MoveisCorporativosSaoLourencoPage /> },
  { path: '/moveis-corporativos-abreu-e-lima', element: <MoveisCorporativosAbreuELimaPage /> },
  { path: '/moveis-corporativos-ipojuca', element: <MoveisCorporativosIpojucaPage /> },
  { path: '/moveis-corporativos-serra-talhada', element: <MoveisCorporativosSerraTalhadaPage /> },
  { path: '/moveis-corporativos-carpina', element: <MoveisCorporativosCarpina /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/glossario', element: <GlossarioPage /> },
  { path: '/calculadora', element: <CalculadoraPage /> },
  { path: '/consultoria-ia', element: <ConsultoriaIAPage /> },
  { path: '/hotelaria', element: <HotelariaPage /> },
  { path: '/academia', element: <AcademiaPage /> },
  { path: '/coworking', element: <CoworkingPage /> },
  { path: '/beleza-estetica', element: <BelezaEsteticaPage /> },
  { path: '/farmacias', element: <FarmaciasPage /> },
  { path: '/pet-shop', element: <PetShopPage /> },
  { path: '/contabilidade', element: <ContabilidadePage /> },
  { path: '/imobiliarias', element: <ImobiliariasPage /> },
  { path: '/segmentos', element: <SegmentosPage /> },
  { path: '/rastreamento', element: <RastreamentoPage /> },
  { path: '/painel-clientes', element: <PainelClientesPage /> },
  { path: '/caixinha-de-ajuda', element: <CaixinhaDeAjudaPage /> },
  {
    path: '/painel',
    element: <PainelShell />,
    children: [
      { index: true, element: <VisaoGeral /> },
      {
        path: 'crm',
        element: <CrmModule />,
        children: [
          { index: true, element: <Navigate to="leads" replace /> },
          { path: 'filas', element: <CrmFilas /> },
          { path: 'leads', element: <CrmLeads /> },
          { path: 'pipeline', element: <CrmPipeline /> },
          { path: 'whatsapp', element: <CrmWhatsapp /> },
          { path: 'calendario', element: <CrmCalendario /> },
          { path: 'funil', element: <CrmFunil /> },
          { path: 'ia', element: <CrmIa /> },
        ],
      },
      {
        path: 'oportunidades',
        element: <OportunidadesModule />,
      },
      {
        path: 'projetos-estrategicos',
        element: <ProjetosEstrategicos />,
      },
      { path: 'projetos', element: <Navigate to="projetos-estrategicos" replace /> },
      { path: 'licitacoes', element: <Licitacoes /> },
      { path: 'clientes', element: <ClientesModule /> },
      { path: 'clientes/:id', element: <ClienteDetail /> },
      { path: 'contatos/:id', element: <ContatoDetail /> },
      {
        path: 'radar',
        element: <RadarModule />,
        children: [
          { index: true, element: <RadarDashboard /> },
          { path: 'oportunidades', element: <RadarOportunidades /> },
          { path: 'oportunidades/:id', element: <RadarOportunidadeDetail /> },
          { path: 'obras', element: <RadarObras /> },
          { path: 'empresas', element: <RadarEmpresas /> },
          { path: 'fontes', element: <RadarFontes /> },
          { path: 'arquivadas', element: <RadarArquivadas /> },
        ],
      },
      {
        path: 'resultados',
        element: <Resultados />,
      },
      {
        path: 'fornecedores',
        element: <FornecedoresModule />,
      },
      {
        path: 'relacionamentos',
        element: <RelacionamentosModule />,
      },
      {
        path: 'configuracoes',
        element: <Configuracoes />,
      },
    ],
  },
  { path: '/painel-pedidos', element: <Navigate to="/painel/crm" replace /> },
  { path: '/contrato/:orderId', element: <ContratoPage /> },
  { path: '/contrato-importado/:contractId', element: <ContratoImportadoPage /> },
  { path: '/google-callback', element: <GoogleCallbackPage /> },
  { path: '/links', element: <LinksPage /> },
  { path: '/ednilson-leocadio', element: <EdnilsonLeocadioPage /> },
  { path: '/projetos-corporativos', element: <ProjetosCorporativosPage /> },
  { path: '/carpete-corporativo', element: <CarpeteCorporativoPage /> },
  { path: '/mobiliario-urbano', element: <MobiliarioUrbanoPage /> },
  { path: '/mobiliario-pracas-alimentacao', element: <PracasAlimentacaoPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
